import type { QueryClient } from '@/api/zustandQuery';

// Final approval uses its own query keys rather than the dashboard page key.
// Refresh both reads so completed outputs and approvals cannot leave a stale
// failure beside a newer package preview.
export const FINAL_LISTING_INVALIDATION_EVENTS = [
  'listing.release.updated',
  'listing.refine.updated',
  'listing.published',
  'content.version.created',
  'content.approved',
  'review.completed',
  'review.decision.updated',
  'slideshow.render.queued',
  'slideshow.output.completed',
  'slideshow.render.completed',
  'slideshow.render.recovered',
  'slideshow.render.failed',
  'slideshow.render.cancelled',
] as const;

const finalListingEvents = new Set<string>(FINAL_LISTING_INVALIDATION_EVENTS);

export function invalidateFinalListingQueries(
  queryClient: Pick<QueryClient, 'invalidateQueries'>,
  event: string,
): void {
  if (!finalListingEvents.has(event)) return;
  void queryClient.invalidateQueries({ queryKey: ['final-approval-queue'] });
  void queryClient.invalidateQueries({ queryKey: ['final-approval-detail'] });
}
